import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "proptypes";
import { scroller } from "ux-helpers";

import menuIcon from "../../../assets/menu-icon-green.png";
import greenLogo from "../../../assets/give-logo-green.png";
import "./ScrolledHeader.scss";

const toggleHeader = () => {
  const target = document.getElementsByClassName("scrolled-header")[0];
  if (
    document.body.scrollTop > 130 ||
    document.documentElement.scrollTop > 130
  ) {
    target.classList.add("header-toggle");
  } else if (target) {
    target.classList.remove("header-toggle");
  }
};

window.onscroll = () => {
  toggleHeader();
};

const ScrolledHeader = ({ toggleSideBar, onLogout, pathname }) => {
  const loggedIn = window.localStorage.sessionToken ? (
    <button className="logout default-btn" onClick={onLogout}>
      <strong>Logout</strong>
    </button>
  ) : (
    <button
      className="login default-btn"
      onClick={() => {
        if (pathname === "/") {
          scroller("login-form");
        }
      }}
    >
      <strong>Login</strong>
    </button>
  );

  return (
    <div className="header scrolled-header">
      <div className="flex-child-scroll">
        <button className="topnav-btn-dark default-btn" onClick={toggleSideBar}>
          <img className="menu-icon" src={menuIcon} alt="menu" />
          <strong>Menu</strong>
        </button>
      </div>
      <div className="flex-child-scroll">
        <a href="https://www.givevolunteers.org">
          <img className="logo" src={greenLogo} alt="Dark GIVE tree logo" />
        </a>
      </div>
      <div className="flex-child-scroll">
        <Link to="/">{loggedIn}</Link>
      </div>
    </div>
  );
};

ScrolledHeader.propTypes = {
  pathname: PropTypes.string.isRequired,
  onLogout: PropTypes.func.isRequired,
  toggleSideBar: PropTypes.func.isRequired
};

export default ScrolledHeader;
